import { useInfiniteQuery } from "@tanstack/react-query";

import { getProperties } from "@/shared/requests/property";

import { PROPERTY_QUERY_KEY } from "./queryKey";

export function useInfiniteListProperties(params: {
  page?: number;
  page_size?: number;
  property_name?: string;
  address?: string;
  property_type?: string;
  device_type?: string;
}) {
  return useInfiniteQuery(
    [PROPERTY_QUERY_KEY, params],
    ({ pageParam = params }) => getProperties(pageParam),
    {
      getNextPageParam: (lastPage, allPage) => {
        const totalPage = lastPage.data.total_pages;
        const currentPage = allPage.length;
        if (currentPage >= totalPage) return false;
        const newParams = { ...params, page: currentPage + 1 };
        return newParams;
      },
    }
  );
}
